import React, { useEffect } from "react";
import { EmployeeHistoryModel } from "../Managers/dataStructures";
import { fetchEmployeeHistory } from "../Managers/wepApiManager";
import { getCurrentUser } from "../Managers/profileManager";
import { ActivityIndicator } from "../Managers/utilityComponents";
import EmployeeHistoryReport from "./EmployeeHistoryReport";
import { getLanguage } from "../Managers/dataProvider";

export default function EmployeeHistory() {
  const [historyModel, setHistoryModel] = React.useState<
    EmployeeHistoryModel | undefined
  >();
  const [isHUD, setIsHud] = React.useState<boolean>(false);
  const isEnglish = getLanguage();

  useEffect(() => {
    setIsHud(true);
    fetchEmployeeHistory(
      getCurrentUser().user_id,
      (history: EmployeeHistoryModel | undefined) => {
        setIsHud(false);
        setHistoryModel(history);
      }
    );
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "My Report" : "Meine Berichte"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Report of the past work that I have done."
              : "Meine Arbeitsberichte"}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none"></div>
      </div>
      {isHUD === true ? (
        <div className="mt-5 flex items-center justify-center">
          {ActivityIndicator(1)}
        </div>
      ) : (
        <div>
          <EmployeeHistoryReport
            array_daily_logs={
              historyModel !== undefined ? historyModel.array_dailyLogs : []
            }
          />
        </div>
      )}
    </div>
  );
}
